<template>
  <div
    @click="
      $emit('click', $event);
      $emit('input', !value);
    "
    class="toggle--wrapper relative flex items-center"
    :class="{ disabled }"
  >
    <div class="toggle--indicator mr-15" :class="{ checked: value }"></div>
    <span>{{ label }}</span>
  </div>
</template>

<script>
export default {
  props: ["value", "label", "disabled"],
};
</script>
